<template>
  <v-dialog v-model="dialog_send_mailing" persistent max-width="800px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Gerar Disparo</span>
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3 md3>
                <v-autocomplete
                  :items="types"
                  item-value="value"
                  item-text="text"
                  label="Tipo"
                  v-model.lazy="type"
                  :rules="[(v) => !!v || 'Por favor, selecione o tipo!']"
                  :hint="'Selecione um tipo'"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Nome da Exportação"
                  v-model="name"
                  required
                  :rules="[
                    (v) =>
                      !!v || 'Por favor, informe um nome para a exportação',
                    (v) =>
                      v.length > 10 ||
                      'Ops. O nome da exportação deve conter no mínimo 10 caracteres',
                  ]"
                  :hint="'Mínimo de 10 caracteres'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="selected_power_plants"
                  :items="power_plants"
                  item-text="name"
                  item-value="power_plant_id"
                  return-object
                  label="Planta"
                  :rules="[
                    (v) =>
                      v.length > 0 ||
                      'Por favor selecione no mínimo uma planta.',
                  ]"
                  multiple
                  chips
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="selected_uc_status"
                  :items="uc_status"
                  item-text="name"
                  item-value="id"
                  return-object
                  label="UC Status"
                  :rules="[
                    (v) =>
                      v.length > 0 ||
                      'Por favor selecione no mínimo um status.',
                  ]"
                  multiple
                  chips
                ></v-select>
              </v-flex>
              <v-flex xs12 sm9 md9 v-if="type === 'email'">
                <v-text-field
                  label="Sendgrid Template"
                  v-model="sendgrid_template"
                  required
                  :rules="[(v) => !!v || 'Por favor, informe o id do template']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm9 md9 v-if="type === 'whatsapp'">
                <v-text-field
                  label="MessageBird Template"
                  v-model="messagebird_template"
                  required
                  :rules="[(v) => !!v || 'Por favor, informe o id do template']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 v-if="type === 'whatsapp'">
                <v-text-field
                  label="Envios por hora"
                  v-model="rate_per_hour"
                  required
                  :rules="[(v) => !!v || 'Por favor, informe um número']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  name="description"
                  label="Descrição"
                  v-model="description"
                  value=""
                  hint="Adicione uma descrição para sua exportação"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-alert
            :value="alert.value"
            :color="alert.color"
            :icon="alert.icon"
            outline
            dismissible
          >
            <p v-html="alert.message"></p>
          </v-alert>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_send_mailing = false"
            >fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="!valid || loading"
            @click.prevent="validate"
            type="submit"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>

      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-form>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import firestore from "../../firebase/firestore";
// import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants"
import { mapState, mapActions } from "vuex";

export default {
  data: function () {
    return {
      types: [
        {
          text: "Email",
          value: "email",
        },
        {
          text: "WhatsApp",
          value: "whatsapp",
        },
      ],
      type: null,
      rate_per_hour: "",
      sendgrid_template: "",
      messagebird_template: "",
      power_plants: [],
      selected_power_plants: [],
      uc_status: [
        { id: "activated", name: "Ativo" },
        { id: "canceled", name: "Cancelado" },
        { id: "canceling", name: "Cancelando" },
        { id: "pending", name: "Pendente" },
      ],
      selected_uc_status: [],
      dialog_send_mailing: false,
      valid: false,
      name: "",
      description: "",
      loading: false,
      color: null,
      colors: ["purple", "info", "success", "warning", "error"],
      alert: {
        value: false,
        color: "success",
        icon: "check_circle",
        message: "",
      },
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    };
  },
  watch: {
    power_plants() {
      if (!this.power_plants && this.powerplants) {
        this.power_plants = this.filterPowerPlants(this.powerplants);
      }
    },
  },
  async created() {
    if (!this.powerplants) {
      const pp = await this.getPowerPlants();
      this.power_plants = this.filterPowerPlants(pp);
    }

    var vm = this;
    eventBus.$on("dialog_send_mailing", function (value) {
      vm.clearFilters();
      vm.dialog_send_mailing = value;
    });
  },
  methods: {
    ...mapActions(["getPowerPlants"]),
    clearFilters() {
      this.valid = false;
      this.selected_power_plants = [];
      this.selected_uc_status = [];
      this.name = "";
      this.description = "";
      this.sendgrid_template = "";
      this.messagebird_template = "";
      this.rate_per_hour = "";
      this.type = null;
      this.alert = {
        value: false,
        color: "success",
        icon: "check_circle",
        message: "",
      };
    },
    filterPowerPlants(_powerplants) {
      var PowerPlantArray = [];
      if (_powerplants && this.user) {
        if (
          this.user.group &&
          (this.user.group.indexOf("admin") >= 0 ||
            this.user.group.indexOf("financial") >= 0)
        )
          return _powerplants;
        const user_pp = this.user.powerplants || this.user.power_plants;

        if (user_pp && user_pp.length > 0) {
          _powerplants.filter((power_plant) => {
            return user_pp.filter((power_plant2) => {
              if (power_plant2.power_plant_id === power_plant.id) {
                PowerPlantArray.push(power_plant);
              }
            });
          });
        }
      }
      return PowerPlantArray;
    },
    showAlert(message, color, icon) {
      this.alert = {
        value: true,
        message,
        color,
        icon,
      };
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let export_obj = {
          created_at: new Date(),
          owner: this.user.email,
          ownerHash: this.user.id,
          solved: false,
          type: this.type,
          name: this.name,
          description: this.description,
          power_plants: this.selected_power_plants.map((e) => e.power_plant_id),
          uc_status: this.selected_uc_status.map((e) => e.id),
          dynamic_data: ["name"],
        };
        if (this.type === "email") {
          export_obj.sendgrid_template = this.sendgrid_template;
        } else if (this.type === "whatsapp") {
          export_obj.messagebird_template = this.messagebird_template;
          export_obj.rate_per_hour = parseInt(this.rate_per_hour);
        }
        firestore
          .collection("bulk_messaging")
          .add(export_obj)
          .then(() => {
            this.showAlert(
              "Disparo solicitada com sucesso.",
              "green",
              "check_circle",
            );
            this.loading = false;
          })
          .catch((err) => {
            this.showAlert(
              "Erro ao gerar exportação. " + err,
              "error",
              "warning",
            );
            this.loading = false;
          });
      }
    },
  },
  computed: {
    ...mapState(["powerplants", "user"]),
  },
};
</script>
